import AssociationForm from './AssociationForm'

export default AssociationForm
